import { API_CONFIG } from '../lib/apiConfig';
import { createPngMetaOverlayHook } from '../lib/hookFactories';

/**
 * Resolves the private-timberland focus mask PNG for a (mill, drive_time).
 * Mask is layered above the categorical Forest Ownership overlay during
 * scenario steps that talk specifically about private timberlands — it's
 * transparent over family + corporate pixels and translucent black over
 * everything else, so the private classes pop and the rest dim.
 *
 * Bounds match the categorical FO overlay exactly (same offline transform),
 * so this hook reuses the existing `foOverlayMeta` sidecar instead of
 * shipping a duplicate `.meta.json`.
 */
export const useFoPrivateMaskOverlay = createPngMetaOverlayHook({
  metaPath: API_CONFIG.s3.paths.foOverlayMeta,
  pngPath: API_CONFIG.s3.paths.foPrivateMaskOverlay,
});
